import { render, staticRenderFns } from "./ChannelSettingsOverview.vue?vue&type=template&id=517575ea&scoped=true&"
import script from "./ChannelSettingsOverview.vue?vue&type=script&lang=js&"
export * from "./ChannelSettingsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517575ea",
  null
  
)

export default component.exports